import React, { useState } from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useParams } from "react-router-dom";

// import JS files
import NextPrevCard from "./NextPrevCard";
import useFetch from "../../context/useFetch";

// import others files

const NextPrevNews = (props) => {
  const [newsItems, setNewsItems] = useState([]);
  const [status, setStatus] = useState();
  const { id } = useParams();
  const getNewsTwo = useFetch({
    method: "get",
    url: `News_Service/${id}/get_two_news`,
    noHeader: true,
    trigger: true,
    argFunc: (res) => {
      setNewsItems(res);
    },
  });

  const getNextNews = useFetch({
    method: "get",
    url: `News_Service/${id}/get_two_news`,
    params: { nums: 1, ids: newsItems.map((it) => it.id) },
    noHeader: true,
    // trigger: true,
    argFunc: (res) => {
      let bf = [...newsItems];
      if (status == "next") bf[1] = res[0];
      else bf[0] = res[0];

      setNewsItems(bf);
    },
  });
  const change_news = (state) => {
    setStatus(state);
    getNextNews.reFetch();
  };
  return (
    <>
      {newsItems.length >= 2 && (
        <div className="grid grid-cols-2 gap-8 md:gap-16 mt-12">
          <div className="">
            <div className="flex  items-center">
              <div
                onClick={() => change_news("pre")}
                className="bg-mygrays-100 p-1 rounded-lg transition-all hover:scale-110  cursor-pointer"
              >
                <ArrowForwardIosIcon className="text-myblacks-100 transition-all hover:text-myblacks-400" />
              </div>
              <span className="text-sm md:text-base mr-4 text-myblacks-200 transition-all hover:text-myblacks-400 cursor-pointer">
                مطلب قبلی
              </span>
            </div>
            <div className="mt-4">
              <NextPrevCard
                id={newsItems[0].id}
                cover={newsItems[0].news_detail[0].cover}
                sub_header={newsItems[0].news_detail[0].sub_header}
                header={newsItems[0].news_detail[0].header}
              />
            </div>
          </div>
          <div className="">
            <div className="flex  items-center justify-end">
              <span className=" text-sm md:text-base ml-4 text-myblacks-200 transition-all hover:text-myblacks-400 cursor-pointer">
                مطلب بعدی
              </span>
              <div
                onClick={() => change_news("next")}
                className="bg-mygrays-100 p-1 rounded-lg transition-all hover:scale-110  cursor-pointer"
              >
                <ArrowBackIosNewIcon className="text-myblacks-100 transition-all hover:text-myblacks-400" />
              </div>
            </div>
            <div className="mt-4">
              <NextPrevCard
                id={newsItems[1].id}
                cover={newsItems[1].news_detail[0].cover}
                sub_header={newsItems[1].news_detail[0].sub_header}
                header={newsItems[1].news_detail[0].header}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NextPrevNews;
